// Discriminator sent on the polymorphic Booking payload to mark a closed-day booking. The generated
// client types it as a plain `string`, so it is not inferred — we set it explicitly when building a
// request. Shared occurrence constants live in `../Bookings/shared`.
export const CLOSED_DAY_BOOKING_TYPE = 'CLOSED_DAY' as const;

// Default end time pre-filled when switching a closure to partial-day, so only the start needs
// picking. It coincides with the end-of-day sentinel but is not the same concept, so it carries its
// own value: retiming the sentinel must not silently move this default. A Closed day is always a
// SingleOccurrence (never recurring), and a full-day closure is stored as the whole calendar day
// using the shared FULL_DAY_* sentinels in `../Bookings/shared/bookingConstants`.
export const DEFAULT_PARTIAL_END_TIME = '23:59' as const;
